var _path, _path2, _circle, _path3, _ellipse, _path4, _path5, _path6, _path7, _circle2, _ellipse2, _path8, _path9, _path10, _path11, _circle3, _rect, _rect2, _rect3, _rect4, _path12, _path13, _rect5, _circle4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgParentPhone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 193,
    height: 175,
    viewBox: "0 0 193 175",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M135.869 88.3501C135.869 117.908 110.196 141.87 78.5268 141.87C46.8576 141.87 21.1846 117.908 21.1846 88.3501C21.1846 58.7922 46.8576 34.8307 78.5268 34.8307C110.196 34.8307 135.869 58.7922 135.869 88.3501Z",
    fill: "url(#paint0_linear_1954_539)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8545 22.9375H82.3496V36.5297H73.8545V22.9375Z",
    fill: "url(#paint1_linear_1954_539)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 78.1022,
    cy: 12.7428,
    r: 11.8932,
    fill: "#000F20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.9512 146.117C112.732 146.117 140.116 120.634 140.116 89.1996C140.116 70.1935 130.105 53.3632 114.723 43.0256C113.294 42.0657 111.596 41.6045 109.875 41.6045H48.0269C46.306 41.6045 44.6082 42.0657 43.1798 43.0256C27.7971 53.3632 17.7861 70.1935 17.7861 89.1996C17.7861 120.634 45.1707 146.117 78.9512 146.117Z",
    fill: "url(#paint2_linear_1954_539)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 35.4218,
    cy: 125.705,
    rx: 4.49752,
    ry: 8.43286,
    transform: "rotate(-44.9872 35.4218 125.705)",
    fill: "#236DC1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.8491 134.093C47.1541 131.754 45.2295 126.12 40.5505 121.51C35.8715 116.9 30.2099 115.06 27.905 117.399C25.6 119.739 27.5245 125.372 32.2035 129.982C36.8825 134.592 42.5441 136.433 44.8491 134.093ZM40.8294 131.094C42.296 129.605 41.0714 126.02 38.0942 123.087C35.117 120.154 31.5146 118.983 30.048 120.471C28.5813 121.96 29.8059 125.545 32.7831 128.478C35.7603 131.411 39.3627 132.582 40.8294 131.094Z",
    fill: "#468BDC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9862 127.684L41.6136 124.347L34.9386 119.092L32.3112 122.429L38.9862 127.684ZM24.7857 132.1L25.6187 136.265L24.7857 132.1ZM15.7998 123.075C14.7053 121 12.136 120.205 10.0611 121.3C7.98625 122.394 7.19154 124.964 8.28609 127.038L15.7998 123.075ZM32.3112 122.429C29.9784 125.393 28.267 126.57 27.1866 127.097C26.0349 127.659 25.465 127.633 23.9527 127.935L25.6187 136.265C26.2301 136.143 28.4724 135.922 30.9116 134.732C33.4222 133.507 36.0804 131.375 38.9862 127.684L32.3112 122.429ZM23.9527 127.935C24.1657 127.893 23.8796 127.983 22.8906 127.676C22.0229 127.407 20.9717 126.943 19.8911 126.335C18.8159 125.729 17.8168 125.038 17.0358 124.374C16.6476 124.044 16.344 123.746 16.1228 123.496C16.0137 123.373 15.934 123.272 15.8784 123.194C15.851 123.156 15.8314 123.127 15.8182 123.106C15.8049 123.084 15.7995 123.074 15.7998 123.075L8.28609 127.038C9.07766 128.539 10.3468 129.837 11.5317 130.845C12.7803 131.907 14.2381 132.9 15.721 133.736C17.1986 134.568 18.807 135.304 20.3744 135.79C21.8205 136.238 23.7451 136.64 25.6187 136.265L23.9527 127.935Z",
    fill: "#000F20"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9541 127.723L41.6215 124.418L35.0103 119.083L32.3429 122.389L38.9541 127.723ZM27.3343 131.675L25.8827 127.683L27.3343 131.675ZM16.3886 121.546C15.4864 119.381 12.9995 118.357 10.8341 119.259C8.66867 120.161 7.64468 122.648 8.54694 124.813L16.3886 121.546ZM8.54694 124.813C8.76244 125.331 9.01082 125.829 9.28278 126.307L16.6667 122.107C16.5506 121.903 16.4591 121.715 16.3886 121.546L8.54694 124.813ZM26.8069 136.153C27.4631 136.062 28.1282 135.906 28.7859 135.667L25.8827 127.683C25.8355 127.7 25.7569 127.723 25.6389 127.739L26.8069 136.153ZM28.7859 135.667C28.9944 135.591 29.1883 135.522 29.3689 135.46L26.605 127.427C26.3789 127.505 26.1386 127.59 25.8827 127.683L28.7859 135.667ZM38.5287 128.252C38.6651 128.082 38.8067 127.906 38.9541 127.723L32.3429 122.389C32.1904 122.578 32.0438 122.76 31.9029 122.935L38.5287 128.252Z",
    fill: "#0F4688"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.5005 126.755C43.5983 125.01 42.2578 123.192 40.5505 121.51C37.9029 118.902 34.9406 117.18 32.4499 116.6L33.5009 120.12C34.9579 120.593 36.6044 121.619 38.0942 123.087C39.2889 124.264 40.2013 125.546 40.7709 126.755H44.5005Z",
    fill: "#468BDC"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.11818,
    cy: 117.705,
    r: 9.02609,
    transform: "rotate(-30.6263 9.11818 117.705)",
    fill: "#85B7F2"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.49752,
    cy: 8.43286,
    rx: 4.49752,
    ry: 8.43286,
    transform: "matrix(-0.875304 -0.483572 -0.483572 0.875304 141.972 108.379)",
    fill: "#236DC1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.22 124.254C124.358 122.644 124.648 116.698 127.868 110.973C131.088 105.248 136.019 101.913 138.882 103.523C141.744 105.133 141.454 111.079 138.234 116.804C135.014 122.529 130.083 125.864 127.22 124.254ZM130.253 120.259C128.431 119.235 128.616 115.451 130.665 111.809C132.714 108.166 135.852 106.044 137.673 107.068C139.494 108.093 139.31 111.876 137.261 115.519C135.212 119.162 132.074 121.284 130.253 120.259Z",
    fill: "#468BDC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M131.079 116.473L127.63 113.993L132.59 107.096L136.039 109.576L131.079 116.473ZM145.947 116.787L146.299 121.019L145.947 116.787ZM152.084 105.627C152.561 103.33 154.81 101.855 157.107 102.333C159.404 102.81 160.878 105.059 160.401 107.356L152.084 105.627ZM136.039 109.576C139.1 111.778 141.071 112.436 142.255 112.643C143.517 112.865 144.057 112.682 145.594 112.554L146.299 121.019C145.678 121.071 143.462 121.48 140.789 121.011C138.037 120.529 134.893 119.216 131.079 116.473L136.039 109.576ZM145.594 112.554C145.378 112.572 145.678 112.579 146.543 112.01C147.303 111.512 148.185 110.776 149.054 109.892C149.92 109.012 150.689 108.072 151.255 107.217C151.537 106.792 151.746 106.422 151.89 106.121C151.961 105.972 152.009 105.853 152.041 105.763C152.057 105.719 152.068 105.685 152.074 105.661C152.081 105.637 152.084 105.626 152.084 105.627L160.401 107.356C160.056 109.017 159.195 110.615 158.336 111.912C157.43 113.278 156.304 114.636 155.11 115.849C153.921 117.058 152.579 118.21 151.207 119.111C149.941 119.942 148.203 120.861 146.299 121.019L145.594 112.554Z",
    fill: "#000F20"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M131.121 116.503L127.643 114.065L132.52 107.108L135.998 109.547L131.121 116.503ZM143.381 117.084L143.671 112.846L143.381 117.084ZM151.096 104.321C151.363 101.99 153.47 100.318 155.8 100.586C158.131 100.853 159.803 102.96 159.535 105.29L151.096 104.321ZM159.535 105.29C159.471 105.847 159.371 106.395 159.242 106.93L150.984 104.937C151.039 104.709 151.075 104.503 151.096 104.321L159.535 105.29ZM145.127 121.241C144.472 121.335 143.789 121.369 143.091 121.321L143.671 112.846C143.721 112.849 143.803 112.849 143.921 112.832L145.127 121.241ZM143.091 121.321C142.87 121.306 142.664 121.294 142.474 121.284L142.906 112.8C143.145 112.812 143.399 112.827 143.671 112.846L143.091 121.321ZM131.677 116.893C131.499 116.767 131.314 116.637 131.121 116.503L135.998 109.547C136.197 109.686 136.388 109.82 136.572 109.95L131.677 116.893Z",
    fill: "#0F4688"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.524 117.107C125.908 115.18 126.693 113.062 127.868 110.973C129.69 107.734 132.06 105.259 134.293 104.013L134.258 107.686C132.988 108.544 131.69 109.986 130.665 111.809C129.843 113.27 129.321 114.755 129.108 116.074L125.524 117.107Z",
    fill: "#468BDC"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.02609,
    cy: 9.02609,
    r: 9.02609,
    transform: "matrix(-0.967893 -0.251362 -0.251362 0.967893 168.024 92.1494)",
    fill: "#85B7F2"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 74.9082,
    y: 123.18,
    width: 1.27427,
    height: 8.9199,
    rx: 0.637136,
    fill: "#5998E1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 82.5537,
    y: 123.18,
    width: 1.27427,
    height: 8.9199,
    rx: 0.637136,
    fill: "#5998E1"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 78.7314,
    y: 120.631,
    width: 1.27427,
    height: 15.2913,
    rx: 0.637136,
    fill: "#5998E1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 29.885,
    y: 56.9182,
    width: 98.5437,
    height: 51.8204,
    rx: 25.9102,
    fill: "#000F20",
    stroke: "#458DDE",
    strokeWidth: 3.39806
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2637 79.8545C67.2637 78.7389 67.044 77.6342 66.6171 76.6036C66.1902 75.5729 65.5644 74.6364 64.7756 73.8475C63.9867 73.0587 63.0502 72.433 62.0195 72.006C60.9889 71.5791 59.8842 71.3594 58.7686 71.3594C57.653 71.3594 56.5483 71.5791 55.5176 72.006C54.487 72.433 53.5505 73.0587 52.7616 73.8475C51.9728 74.6364 51.347 75.5729 50.9201 76.6036C50.4932 77.6342 50.2734 78.7389 50.2734 79.8545",
    stroke: "#72B2FF",
    strokeWidth: 4.24757,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M109.739 79.8545C109.739 78.7389 109.52 77.6342 109.093 76.6036C108.666 75.5729 108.04 74.6364 107.251 73.8475C106.462 73.0587 105.526 72.433 104.495 72.006C103.464 71.5791 102.36 71.3594 101.244 71.3594C100.129 71.3594 99.0239 71.5791 97.9932 72.006C96.9625 72.433 96.026 73.0587 95.2372 73.8475C94.4483 74.6364 93.8226 75.5729 93.3957 76.6036C92.9688 77.6342 92.749 78.7389 92.749 79.8545",
    stroke: "#72B2FF",
    strokeWidth: 4.24757,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 146.164,
    y: 74.127,
    width: 22.0874,
    height: 43.3252,
    rx: 4.24757,
    transform: "rotate(-21.0829 146.164 74.127)",
    fill: "#FF9154"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 164.133,
    cy: 72.5997,
    r: 2,
    transform: "rotate(-38.535 164.133 72.5997)",
    fill: "#F56414"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1954_539",
    x1: 78.5268,
    y1: 22.9375,
    x2: 78.5268,
    y2: 141.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58A1FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#7E9DC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1954_539",
    x1: 78.5268,
    y1: 22.9375,
    x2: 78.5268,
    y2: 141.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58A1FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#7E9DC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1954_539",
    x1: 78.9512,
    y1: 32.2821,
    x2: 78.9512,
    y2: 146.117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4CEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#83B5F1"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgParentPhone);
export default __webpack_public_path__ + "static/media/parent_phone.992cea78ccbdde43df82c3f02cddb8db.svg";
export { ForwardRef as ReactComponent };